import React, { useContext,useState } from 'react';
import { Link } from "react-router-dom";
import { GlobalContext } from '../../GlobalContext';
import { AppRefreshContext } from '../../AppRefresh';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { methods } from '../../Validation';

const Login = () => {
  
  const { refreshApp } = useContext(AppRefreshContext);
  const { t, i18n } = useTranslation();

    const [showPassword, setShowPassword] = useState(false);
    const loader = document.getElementById("loder-tive");

  const EyeOpen = (
   <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 4.45962C9.91153 4.16968 10.9104 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C3.75612 8.07914 4.32973 7.43025 5 6.82137" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#1C274C" stroke-width="1.5"/>
</svg>
  );

  const EyeClosed = (
   <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.83 9.17999C14.2706 8.61995 13.5576 8.23846 12.7813 8.08386C12.0049 7.92926 11.2002 8.00851 10.4689 8.31152C9.73758 8.61453 9.11264 9.12769 8.67316 9.78607C8.23367 10.4444 7.99938 11.2184 8 12.01C7.99916 13.0663 8.41619 14.08 9.16004 14.83" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 16.01C13.0609 16.01 14.0783 15.5886 14.8284 14.8384C15.5786 14.0883 16 13.0709 16 12.01" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.61 6.39004L6.38 17.62C4.6208 15.9966 3.14099 14.0944 2 11.99C6.71 3.76002 12.44 1.89004 17.61 6.39004Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.9994 3L17.6094 6.39" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.38 17.62L3 21" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5695 8.42999C20.4801 9.55186 21.2931 10.7496 21.9995 12.01C17.9995 19.01 13.2695 21.4 8.76953 19.23" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
    const [isChecked, setIsChecked] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password:'',
  
      });
         let [formdata_valid_error,setFormDatavalid] = useState({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
      const [errormsg,setErrormsg] = useState(null);
      const [index_dat,setIndex_dat] = useState(1);
      const [index_dat_success,setIndex_dat_success] = useState(1);
         const handleChange = (e) => {
                 const { name, value } = e.target;
                
                 if (name in formdata_valid_error) {
                     if('validtion' in formdata_valid_error[name]){
                    
                       let result = null;
                       let newformdata;
                         for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                             if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                 result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                 }
                            if(result == false){
                             formdata_valid_error[name].error = true;
                             formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                             newformdata = formdata_valid_error[name];
                              setFormDatavalid(prev => ({
                             ...prev,
                             [name]:newformdata
                             }));
                             break;
                            }
                            if(result == true){
                             
                               formdata_valid_error[name].error = false;
                             formdata_valid_error[name].errormsg = null;
                             newformdata = formdata_valid_error[name];
                              setFormDatavalid(prev => ({
                             ...prev,
                             [name]:newformdata
                             }));
                            }
         
                     }
                     
                     }
          
                 }
               
                 setFormData(prev => ({
                   ...prev,
                   [name]: value
                 }));
                 
               };
    const handleChange_chck = (e) => {
    setIsChecked(e.target.checked);
  };

      const handleSubmit = (e) => {
        e.preventDefault(); 
          loader.classList.remove('d-none');
                       let value;
                       for (const name in formData) {
                           value = formData[name];
                           if (name in formdata_valid_error) {
                           if('validtion' in formdata_valid_error[name]){
                          
                             let result = null;
                             let newformdata;
                               for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                                   if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                       result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                       }
                                  if(result == false){
                                   formdata_valid_error[name].error = true;
                                   formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                   break;
                                  }
                                  if(result == true){
                                   
                                     formdata_valid_error[name].error = false;
                                   formdata_valid_error[name].errormsg = null;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                  }
               
                           }
                           
                           }
                
                       }
                           }
               
                           let validation = true;
                            for (const key in formdata_valid_error) {
                               if(formdata_valid_error[key].error == true){
                                 loader.classList.add('d-none');
                                  validation = false; 
                                  break;
                               }
                            }
               
                            if(validation){
                                      if(isChecked){
                                          const parent = document.getElementById("iagree");
                                             if (parent) {
                                                parent.parentElement.classList.remove("error");
                                             }
                                handleSubmit_axios(formData);
                                      }else{    
                                          console.log('Form submitted:', 'faild');
                                          loader.classList.add('d-none');
                                           const parent = document.getElementById("iagree");
                                             if (parent) {
                                                parent.parentElement.classList.add("error");
                                             }
                              }
                               
                            }else{
                               console.log('Form submitted:', 'faild');
                               console.log('Form submitted:', formData);
                            } 
       
       
      };

         const handleSubmit_forget = (e) => {
        e.preventDefault(); 
        let name = 'email'
         loader.classList.remove('d-none');
          let value = formData[name];
                           if (name in formdata_valid_error) {
                           if('validtion' in formdata_valid_error[name]){
                          
                             let result = null;
                             let newformdata;
                               for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                                   if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                       result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                       }
                                  if(result == false){
                                    loader.classList.add('d-none');
                                   formdata_valid_error[name].error = true;
                                   formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                                   newformdata = formdata_valid_error[name];
                                    setFormDatavalid(prev => ({
                                   ...prev,
                                   [name]:newformdata
                                   }));
                                   break;
                                  }
                                  if(result == true){
                                   // console.log(formData.email);

                                     
                                   break;
                                  }
               
                           }

                           handleSubmit_axios_forget(formData.email);
                           
                           }
                
                       }
      
       
      };

      const { siteName } = useContext(GlobalContext);
      let baseUrl = siteName.baseUrl;
      let defult_endpoint = siteName.webEndpoints;

        const handleSubmit_axios_forget = async (email) => {
       
        try {
          let formData_value = {email:email};
          const response = await axios.post(baseUrl+defult_endpoint+'forgot/password', formData_value);
          console.log(response.data);
          let data = response.data.response;
             loader.classList.add('d-none');
          /*call back data*/
          setIndex_dat_success(2);
          setTimeout(function(){
          refreshApp();
            // window.location.replace(window.location.href);
          },2000)
         
        } catch (error) {
          loader.classList.add('d-none');

          setErrormsg(error.response.data.message);
          console.log(error.response.data);
          /*error call back*/
        }
      };  

      const handleSubmit_axios = async (formData) => {

       
        try {
          const response = await axios.post(baseUrl+defult_endpoint+'login', formData);
          console.log(response.data);
          let data = response.data.response;

          

          /*call back data*/
          localStorage.setItem('name', data.fullName);
          localStorage.setItem('token', data.accessToken);
          localStorage.setItem('loginbefore', data.hasLoggedInBefore);
          localStorage.setItem('role', data.role);
          if(data.hasLoggedInBefore){
            refreshApp();
          //  window.location.replace(window.location.href);
          }else{
               loader.classList.add('d-none');
            document.body.removeAttribute("style");
            let el = document.querySelector(".modal-backdrop");
           // el.classList.remove("show", " "); 
           if (el) {
  el.remove(); 
}
         window.location.href = '/#/changepassword';
          }
         
        } catch (error) {
             loader.classList.add('d-none');
          setErrormsg(error.response.data.message);
          console.log(error.response.data);
          /*error call back*/
        }
      };

      
      const email_validation = (validation,value) =>{
        console.log(validation);
        console.log(value);
      };

      const email_validation_data = "email_validation";

      const handleChange_forget = () =>{
   setFormDatavalid({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
 
        setIndex_dat(2)

      } 

      const handleChange_login = () =>{
              setFormDatavalid({//validName
                       password: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Password required"},{keyname:'minLength',methods:'minLength',parmeters:[{min:7}],errormag:"Password min size 8"}],required:true,error:false,errormsg:null
                       },
                       email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
                              {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please type valid email address"}],error:false,errormsg:null},
               
                     });
         setIndex_dat(1)
      }


  return (  
                <div className="modal video-show-modal login-modal fade" id="loginModal"  aria-labelledby="loginModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <Link to="#"><img src="img/CfaN.png" alt=""/></Link>
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                           { index_dat == 1?  <form onSubmit={handleSubmit}>
                                <label htmlFor="username">{t("Email_Address")}</label>
                                <input type="text" validation={JSON.stringify(email_validation_data)} onChange={handleChange} name="email" id="email" placeholder={t("Email_Address")} />
                                 {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                                
                                <div class="form-intem form-item-full"> <label htmlFor="password">{t("Password")}</label><input   type={showPassword ? "text" : "password"} validation={email_validation_data} onChange={handleChange} name="password" placeholder={t("Password")} id="password"  />
                                 {formdata_valid_error.password.error? <div className="error">{formdata_valid_error.password.errormsg}</div> : ''}
                                { errormsg != null? <div className="error">{errormsg}</div> : '' }
                                     <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "10px",
          top: "45%",
          transform: "translateY(-50%)",
          cursor: "pointer"
        }}
      >
        {showPassword ? EyeClosed : EyeOpen}
      </span></div>
                                <div className="form-agree-statement">
                                    <input checked={isChecked}  onChange={handleChange_chck} id="iagree" type="checkbox"/>
                                    <span>{t("Agree_to_")}</span>
                                </div>
                                <input type="submit" value={t('Login')} />

                                <div className="text-center forgot-password-text">
                                    <Link to="#" onClick={handleChange_forget}>{t("Forgot_My_Password")}</Link>
                                </div>
                            </form>
                              : [ index_dat_success == 1? <form onSubmit={handleSubmit_forget}> 
                                 <label htmlFor="username">{t("Email_Address")}</label>
                                <input type="text" validation={JSON.stringify(email_validation_data)} onChange={handleChange} name="email" id="email" placeholder={t("Email_Address")} />
                                                    
                                {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                                { errormsg != null? <div className="error">{errormsg}</div> : '' }
                                <input type="submit" value="Submit" />
                                <div className="text-center forgot-password-text">
                                    <Link to="#" onClick={handleChange_login}>{t("login")}</Link>
                                </div>

                              </form> : <div>Email Sent Successfully</div>]  }
                        </div>
                        </div>
                    </div>
                    </div>
  );
};

export default Login;